import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// Helper: get signed URL for a file
export async function getFileUrl(path) {
  const { data } = await supabase.storage
    .from('consulting-files')
    .createSignedUrl(path, 3600)
  return data?.signedUrl
}

// Helper: upload file to storage
export async function uploadFile(file, path) {
  const { data, error } = await supabase.storage
    .from('consulting-files')
    .upload(path, file, { upsert: false })
  if (error) throw error
  return data
}

// Helper: delete file from storage
export async function deleteFile(path) {
  const { error } = await supabase.storage
    .from('consulting-files')
    .remove([path])
  if (error) throw error
}
